import { useSelector } from "react-redux";

import { useInviteActions } from "store/InvitesSlice";
import { inviteAttributes } from "utils/inviteUtils";

const useInvites = () => {
  const { createInvite, loadInvite, createGuest } = useInviteActions();

  const { invite } = useSelector((state) => state.InvitesSlice);

  const saveInvite = ({ makeThumb, shareThumb, roles, templateId, templateGroupId, themeId }) => {
    const attrs = inviteAttributes({ makeThumb, shareThumb, roles, templateId, templateGroupId, themeId });

    return createInvite(attrs);
  };

  const saveGuest = ({ name, email }) => {
    const body = {
      data: {
        type: "guests",
        attributes: {
          name,
          email,
        },
      },
    };
    return createGuest(invite, body);
  };

  return {
    saveInvite,
    loadInvite,
    invite,
    saveGuest,
  };
};

export default useInvites;
